import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const initPurchaseTermsSlider = () => {
  const sliderEl = document.querySelector(".purchase-terms__slider");
  if (!sliderEl) return;

  const slides = Array.from(sliderEl.querySelectorAll(".purchase-terms__slide"));
  const images = slides.map((slide) => slide.querySelector(".purchase-terms__image"));
  const total = slides.length;

  const revealImage = (image) => {
    if (!image) return;

    const media = image.closest(".purchase-terms__image-wrap");
    const markReady = () => media?.classList.add("is-loaded");
    const decodeAndReveal = () => {
      if (typeof image.decode !== "function") {
        markReady();
        return;
      }

      image.decode().catch(() => {}).finally(markReady);
    };

    if (media?.classList.contains("is-loaded")) return;

    if (!image.complete) {
      if (image.dataset.purchaseTermsRevealBound === "true") return;

      image.dataset.purchaseTermsRevealBound = "true";
      image.addEventListener("load", decodeAndReveal, { once: true });
      image.addEventListener("error", () => {
        media?.classList.add("is-error");
        markReady();
      }, { once: true });
      return;
    }

    if (image.naturalWidth === 0) {
      media?.classList.add("is-error");
      markReady();
      return;
    }

    decodeAndReveal();
  };

  const preloadAround = (instance) => {
    const activeIndex = instance.activeIndex;
    const activeSlide = instance.slides[activeIndex];
    const nextSlide = instance.slides[(activeIndex + 1) % instance.slides.length];

    [activeSlide, nextSlide].forEach((slide) => {
      const image = slide?.querySelector(".purchase-terms__image");

      if (!image) return;

      image.loading = "eager";
      revealImage(image);
    });
  };

  new Swiper(sliderEl, {
    modules: [Autoplay],
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 20,
    loop: total > 2,
    speed: 900,
    watchOverflow: true,
    allowTouchMove: false,
    simulateTouch: false,
    autoplay: {
      delay: 3200,
      disableOnInteraction: false,
    },
    on: {
      init(instance) {
        preloadAround(instance);
      },
      slideChange(instance) {
        preloadAround(instance);
      },
    },
    breakpoints: {
      0: {
        spaceBetween: 24,
      },
      993: {
        spaceBetween: 20,
      },
    },
  });

  images.forEach(revealImage);
};

export default initPurchaseTermsSlider;
